import Intro1 from "components/sliders/Intro1"
import React from "react"

function HeroSlider() {
  return (
    <section className="home-slider position-relative mb-30">
      <div className="container">
        <div className="home-slide-cover mt-30">
          <Intro1 />
          <h1
            className="mx-3"
            style={{
              fontSize: 10,
              position: "absolute",
              color: "#fff",
              top: 0,
            }}
          >
            Idealsply - Learn Explore Play Enjoy{" "}
          </h1>
        </div>
      </div>
    </section>
  )
}

export default HeroSlider
